require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./apis-and-microservices-mongodb-and-mongoose-install-and-set-up-mongoose.json") })
        }
      }, "path---apis-and-microservices-mongodb-and-mongoose-install-and-set-up-mongoose");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---apis-and-microservices-mongodb-and-mongoose-install-and-set-up-mongoose!./.cache/json/apis-and-microservices-mongodb-and-mongoose-install-and-set-up-mongoose.json
// module id = 1292
// module chunks = 231608221292675